import { useIntParam, useLrwSessionAllowedActions } from 'hooks';
import { lrwSessionStore } from 'store';

export const useLinkSpeakingSession = () => {
  const lrwSessionId = useIntParam('sessionId');
  const { canLinkSpeakingSession } = useLrwSessionAllowedActions();

  const { data: availableSpeakingSessions, isLoading: isLoadingAvailableSessions } =
    lrwSessionStore.service.useGetAvailableSpeakingSessionsQuery(
      { lrwSessionId },
      { skip: !canLinkSpeakingSession }
    );

  return {
    availableSpeakingSessions: availableSpeakingSessions,
    isLoadingAvailableSessions,
    canLinkSpeakingSession,
  };
};
